import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import './index.css';
import App from './App';

  const noop = () => {}

  console.log = noop
  console.warn = noop
  console.error = noop
  console.info = noop
  console.debug = noop

  window.onerror = () => true
  window.onunhandledrejection = () => true

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>, 
	document.getElementById('root')
);    